import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
// import reportWebVitals from './reportWebVitals';
import App from "./App";
import { store, history } from "./store";
// import './i18n';
import { Provider } from "react-redux";
const context = React.createContext({});
ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  // <App history={history} />,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
